import React from 'react'
// import About from '../Component/About'
// import AboutBreadcrumb from '../Component/AboutBreadcrumb'
import Header from '../Component/Header'
import Footer from '../Component/Footer'
// import FAQ from '../Component/FAQ'
import CourseSection from '../Component/CourseSection'
import CoureseBreadcrumb from '../Component/CoureseBreadcrumb'
function CoursesPage() {
    return (
        <div>
            <Header />
            <CoureseBreadcrumb />
            <CourseSection />
            <Footer />
        </div>
    )
}

export default CoursesPage